import { createFileRoute, useNavigate } from '@tanstack/react-router';
// Route options read the light search module; the page is code-split with the component.
import { SpacePage } from '@/features/spaces/pages/space-page';

/** A space's bare address opens the first tab the reader may open (the page redirects once it knows). */
export const Route = createFileRoute('/_auth/s/$spaceId/')({
  component: SpaceIndexRoute,
});

function SpaceIndexRoute() {
  const { spaceId } = Route.useParams();
  const navigate = useNavigate();
  return (
    <SpacePage
      spaceId={spaceId}
      onTabChange={(tab) => {
        void navigate({ to: '/s/$spaceId/$tab', params: { spaceId, tab } });
      }}
      onChannelChange={(channel) => {
        void navigate({
          to: '/s/$spaceId/$tab',
          params: { spaceId, tab: 'chat' },
          search: { channel },
        });
      }}
    />
  );
}
